module.exports = __webpack_public_path__ + "img/room-01.d4f83266.jpg";